import { getTransedText } from '../locale';
import dayjs from '../_util/day';

//时间格式化 https://zenlayer.atlassian.net/wiki/spaces/RFD/pages/11808080083
export const getText = function (time, DayLocale) {
  let canShowMonth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const localeName = dayjs.locale() || 'en';

  // 一个月按30天计算，后端也这么定义的
  const {
    days,
    hours,
    minutes,
    seconds,
    milliseconds
  } = time;
  if (days > 30 && canShowMonth) {
    return getTransedText(DayLocale.month, {
      month: Math.floor(days / 30)
    });
  } else if (days > 0) {
    return getTransedText(DayLocale.day, {
      day: days
    });
  } else if (hours > 0) {
    if (minutes > 0) {
      //有分钟，把分钟展示出来
      return getTransedText(DayLocale.hour, [hours]) + (localeName === 'en' ? ' ' : '') +
      //英文中间加空格
      getTransedText(DayLocale.minute, [minutes]);
    } else {
      //0分钟，只展示小时
      return getTransedText(DayLocale.hour, [hours]);
    }
  } else if (minutes > 0) {
    return getTransedText(DayLocale.minute, [minutes]);
  } else {
    return getTransedText(DayLocale.second, [seconds]);
  }
};